import React from "react";
import PropTypes from "prop-types";

import ErrorPage from "components/library/ErrorPage";
import Log from "utils/log";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    Log.logger(error, "error", info, false);
  }

  render() {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} info={this.state.info} />;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
